<script setup>
import { computed, onBeforeUnmount, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import AppShell from './components/AppShell.vue'
import ToastRegion from './components/ToastRegion.vue'
import { session } from './composables/useSession'

const route = useRoute()
const router = useRouter()
const isPublic = computed(() => Boolean(route.meta.public))

function handleUnauthorized() {
  session.user = null
  if (route.name !== 'login') {
    router.replace({ name: 'login', query: { next: route.fullPath } })
  }
}

onMounted(() => window.addEventListener('kurochkino:unauthorized', handleUnauthorized))
onBeforeUnmount(() => window.removeEventListener('kurochkino:unauthorized', handleUnauthorized))
</script>

<template>
  <RouterView v-if="isPublic" />
  <AppShell v-else>
    <RouterView v-slot="{ Component }">
      <Transition name="page" mode="out-in">
        <component :is="Component" :key="route.name" />
      </Transition>
    </RouterView>
  </AppShell>
  <ToastRegion />
</template>
